import React, { useState, useEffect, memo } from "react";
import { API_URL, BASE_URL, IMAGE_URL } from "../../../constants";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setContactIdState, setUserId } from "../../../redux/generalSlice";
import { ThreeCircles } from "react-loader-spinner";
import { Button } from "@mui/material";
import MarqueeText from "../../../components/Marquee";

const CommuterLinkSuggestions = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userToken = useSelector((s) => s.login.data.token);
  const [submitbtn, setSubmit] = useState(false);
  const [loading, setLoading] = useState(true);
  const userMode = useSelector((s) => s.general.data.userType);
  const [option, setOption] = useState("");
  const [userType, setUserType] = useState("");
  const [userData, setUserData] = useState([]);
  const [requests, setRequests] = useState([]);
  const [profile, setProfileData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      await getProfileData();
      await getMemberData();
    };

    fetchData();
    const intervalId = setInterval(fetchData, 120000);
    return () => clearInterval(intervalId);
  }, [userToken]);

  useEffect(() => {
    if (option !== "") {
      getDashboardData();
    }
  }, [option, userToken]);

  const requestRoute = (contact_id) => {
    setSubmit(true);
    if (!submitbtn) {
      dispatch(setContactIdState(contact_id));
      navigate("/request-commuter-profile");
    }
  };

  const route = (contact_id) => {
    setSubmit(true);
    if (!submitbtn) {
      dispatch(setContactIdState(contact_id));
      navigate("/commuter-profile");
    }
  };

  const getProfileData = async () => {
    try {
      const response = await fetch(`${API_URL}/api/v1/profile`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      });

      const jsonresponse = await response.json();
      if (jsonresponse && jsonresponse[0]) {
        if (jsonresponse[0].approval_status === -1) {
          navigate("/rejection");
        }
        setOption(jsonresponse[0].userlist.vehicle_option);
        setProfileData(jsonresponse[0]);
        dispatch(setUserId(jsonresponse[0].id));
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching profile data:", error);
      setLoading(false);
    }
  };

  const getDashboardData = async () => {
    try {
      const response = await fetch(`${API_URL}/api/v1/matches/office`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      });

      const jsonresponse = await response.json();
      let enrichedData = [];

      if (option === 0) {
        setUserType("rider");
        enrichedData = await Promise.all(
          jsonresponse.drivers.map(async (driver) => {
            const price = await getCommuterProfileData(driver.contact_id, "driver");
            return { ...driver, price };
          })
        );
        setUserData(enrichedData);
      } else if (option === 1) {
        setUserType("driver");
        enrichedData = await Promise.all(
          jsonresponse.rider.map(async (rider) => {
            const price = await getCommuterProfileData(rider.contact_id, "rider");
            return { ...rider, price };
          })
        );
        setUserData(enrichedData);
      } else {
        setUserData([]);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  const getCommuterProfileData = async (contact_id, type) => {
    try {
      const endpoint =
        type === "driver"
          ? `${API_URL}/api/v1/commuter/profile/${contact_id}/driver`
          : `${API_URL}/api/v1/commuter/profile/${contact_id}/rider`;

      const response = await fetch(endpoint, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      });

      const jsonresponse = await response.json();
      return jsonresponse.data[0]?.price || null;
    } catch (error) {
        console.error(`Error fetching ${type} profile data:`, error);
      return null;
    }
  };

  const getMemberData = async () => {
    try {
      const response = await fetch(`${API_URL}/api/v1/requests`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      });

      const jsonresponse = await response.json();
      if (jsonresponse.data && jsonresponse.data.length > 0) {
        setRequests(jsonresponse.data);
      }
    } catch (error) {
      console.error("Error fetching member data:", error);
    }
  };

  const RiderCard = memo(({ user }) => {
    const { commuter_image, name, contact_id, req_stage, req_status, price } = user;
  
    return (
      <div className="col-sm-2">
        <div
          className="card"
          style={{
            width: "6.2rem",
            backgroundColor: req_stage === 1 ? "#01183F" : req_stage === 0 ? "#ff8a00" : "#01183F",
          }}
        >
           <div
            className="card-title text-light text-center"
            style={{ width: "6rem", cursor: "pointer" }}
            onClick={() => handleClick(contact_id)}
          >
          {req_stage === 1 || req_stage === 2 ? (
            <img
              src={`${IMAGE_URL}${commuter_image}`}
              className="card-img-top w-40px m-auto mt-3"
              style={{ aspectRatio: "22/29" }}
              alt="Commuter"
            />
          ) : (
            <img
              src={`${BASE_URL}/assets/images/Vector.png`}
              className="card-img-top w-40px m-auto mt-3"
              alt="Placeholder"
            />
          )}
         
            {req_stage === 1 || req_stage === 2 ? name : `Member ${contact_id}`}
          </div>
        </div>
        {/* <Button>Price: {price !== null ? price : "N/A"}</Button> */}
      </div>
    );
  });

  const DriverCard = memo(({ user }) => {
    const { commuter_image, name, contact_id, req_stage, req_status, price } = user;

    return (
      <div className="col-sm-2">
        <div
          className="card"
          style={{
            width: "6.2rem",
            backgroundColor: req_stage === 1 ? "#01183F" : req_stage === 0 ? "#FFC738" : "#01183F",
          }}
        >
           <div
            className="card-title text-center text-light"
            style={{ width: "6rem", cursor: "pointer" }}
            onClick={() => handleClick(contact_id)}
          >
          {req_stage === 1 || req_stage === 2 ? (
            <img
              src={`${IMAGE_URL}${commuter_image}`}
              className="card-img-top w-40px m-auto mt-3"
              style={{ aspectRatio: "22/29" }}
              alt="Commuter"
            />
          ) : (
            <img
              src={`${BASE_URL}/assets/images/Vector.png`}
              className="card-img-top w-40px m-auto mt-3"
              alt="Placeholder"
            />
          )}
            {req_stage === 1 || req_stage === 2 ? name : `Member ${contact_id}`}
          </div>
        </div>
        {/* <Button>Price: {price !== null ? price : "N/A"}</Button> */}
      </div>
    );
  });

  const handleClick = (contact_id) => {
    // const forms_completed = profile.forms_completed;
    // if (forms_completed === 0) {
    //   const finalUrl = `/complete-final-${userMode}-registration/?contact=${contact_id}`;
    //   alert("Please enter details to view the list....");
    //   navigate(finalUrl);
    // } else {
      route(contact_id);
    // }
  };

  const DefaultCard = memo(() => (
    <div className="col-sm-2">
      <div className="card" style={{ width: "6rem", backgroundColor: "grey" }}>
        <img
          src={`${BASE_URL}/assets/images/Vector.png`}
          className="card-img-top w-40px m-auto mt-3"
          alt="Placeholder"
        />
        <div className="card-title text-light text-center" style={{ width: "6rem", cursor: "pointer" }}>
          Member ID
        </div>
      </div>
      <Button>Price: N/A</Button>
    </div>
  ));

  const RequestCard = memo(({ request }) => {
    const { contact_id, request_stage } = request;
    const { commuter_image, name } = request.user[0];

    return (
      <div className="col-sm-2">
        <div
          className="card"
          style={{
            width: "6.2rem",
            backgroundColor: request_stage === 1 || request_stage === 2 ? "#FF8A00" : "#01183F",
          }}
        >
           <div
            className={`card-title ${request_stage === 2 ? "text-dark" : "text-light"} text-center`}
            style={{ width: "6rem", cursor: "pointer" }}
            onClick={() => requestRoute(contact_id)}
          >
          {request_stage === 1 || request_stage === 2 ? (
            <img
              src={`${IMAGE_URL}${commuter_image}`}
              className="card-img-top imagebackend w-40px m-auto mt-3"
              style={{ aspectRatio: "22/29" }}
              alt="Commuter"
            />
          ) : (
            <img
              src={`${BASE_URL}/assets/images/Vector.png`}
              className="card-img-top w-40px m-auto mt-3"
              alt="Placeholder"
            />
          )}
         
            {request_stage === 1 || request_stage === 2 ? name : `Member ${contact_id}`}
          </div>
        </div>
      </div>
    );
  });

  const RequestDefaultCard = memo(() => (
    <div className="col-sm-2">
      <div className="card" style={{ width: "6rem", backgroundColor: "grey" }}>
        <img
          src={`${BASE_URL}/assets/images/Vector.png`}
          className="card-img-top w-40px m-auto mt-3"
          alt="Placeholder"
        />
        <div className="card-title text-center text-light" style={{ width: "6rem" }}>
          Member ID
        </div>
      </div>
      <Button>Price: N/A</Button>
    </div>
  ));

  return (
    <>
      <div className="card rounded-0 mb-5">
        <div className="card-header rounded-0" style={{ backgroundColor: "#01183F" }}>
          {loading ? (
            <div className="text-center m-auto">
              <div className="d-flex justify-content-center align-items-center vh-10">
                <ThreeCircles
                  height={50}
                  width={50}
                  color="#FFC738"
                  visible={true}
                  ariaLabel="three-circles-rotating"
                />
              </div>
            </div>
          ) : (
            <h4 className="text-center text-warning m-auto fw-bold" style={{ lineHeight: "1" }}>
              {option === 0 ? "GET A SEAT/S IN THEIR CAR" : "TRAVEL BUDDIES FOR YOUR CAR"}
            </h4>
          )}
        </div>
        <div className="card-body">
          <div className="card mt-3 mb-5" style={{ backgroundColor: "#D9D9D9" }}>
            <div className="card-header" style={{ backgroundColor: "#35677e" }}>
              <h5 className="text-white pt-4 mt-2 mx-auto fw-bold">COMMUTERSLINK SUGGESTION</h5>
            </div>
            <div className="card-body" style={{ background: "rgb(214 219 218)" }}>
              <div className="row">
                {userData.length > 0 ? (
                  <p>
                    Based upon your Profile, We have Following <strong>Matches</strong> to Offer
                  </p>
                ) : (
                  <p>
                    We’re sorry! Based on your profile, we currently have no <strong>Matches</strong> to offer.
                  </p>
                )}
                {userData.map((user, index) => {
                  if (userType === "rider" && user.vehicle_option === 1 && user.req_stage !== 3) {
                    return <RiderCard user={user} key={index} />;
                  } else if (userType === "driver" && user.vehicle_option === 0 && user.req_stage !== 3) {
                    return <DriverCard user={user} key={index} />;
                  } else {
                    return <DefaultCard key={index} />;
                  }
                })}
              </div>
              <div className="d-flex flex-row mt-5 mb-3">
                <div className="ml-auto me-3">
                  <img
                    src={`${BASE_URL}/assets/images/Vector.png`}
                    className="card-img-top w-40px m-auto p-2 me-2"
                    style={{ backgroundColor: "#01183F" }}
                    alt="Not found"
                  />
                  <span className="fw-bold">Active</span>
                </div>
                <div className="me-3">
                  <img
                    src={`${BASE_URL}/assets/images/Vector.png`}
                    className="card-img-top w-40px m-auto p-2 me-2"
                    style={{ backgroundColor: "rgb(255, 199, 56)" }}
                    alt="Not found"
                  />
                  <span className="fw-bold">Pending</span>
                </div>
              </div>
            </div>
          </div>
          <div className="card mt-5" style={{ backgroundColor: "#D9D9D9" }}>
            <div className="card-header" style={{ backgroundColor: "#35677e" }}>
              <h5 className="text-white pt-4 mt-2 mx-auto fw-bold">REQUESTS BY MEMBERS</h5>
            </div>
            <div className="card-body" style={{ background: "rgb(214 219 218)" }}>
              <div className="row">
                {requests.length > 0 ? (
                  <p>
                    Based upon your Profile, We have Following <strong>Requests</strong> to Offer
                  </p>
                ) : (
                  <p>
                    We’re sorry! Based on your profile, we currently have no <strong>Requests</strong> to offer.
                  </p>
                )}
                {requests.map((request, index) => (
                  request.request_stage !== 3 ? (
                    <RequestCard key={index} request={request} />
                  ) : (
                    <RequestDefaultCard key={index} />
                  )
                ))}
              </div>
            </div>
            <div className="d-flex flex-row mt-5 mb-3">
              <div className="ml-auto me-3">
                <img
                  src={`${BASE_URL}/assets/images/Vector.png`}
                  className="card-img-top w-40px m-auto p-2 me-2"
                  style={{ backgroundColor: "#01183F" }}
                  alt="Not found"
                />
                <span className="fw-bold">Active</span>
              </div>
              <div className="me-3">
                <img
                  src={`${BASE_URL}/assets/images/Vector.png`}
                  className="card-img-top w-40px m-auto p-2 me-2"
                  style={{ backgroundColor: "rgb(255, 199, 56)" }}
                  alt="Not found"
                />
                <span className="fw-bold">Pending</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CommuterLinkSuggestions;